// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"189":"840b3094","787":"f1319526"}[chunkId] + ".chunk.js";
};